/**
 * Helpers for adding consistent privacy attributes to DOM nodes.
 * These attributes are used by Datadog session replay masking logic and Microsoft Clarity.
 *
 * "allow" - show everything.
 * "mask" - replace text content with *** (mask all descendant text)
 * "hidden" - element is completely removed from session replay
 * "mask-user-input" - mask only user-typed input values (text still visible, inputs obscured)
 *
 */
export type DatadogPrivacyMode = "allow" | "mask" | "hidden" | "mask-user-input";

export type PrivacyAttributes = {
    "data-privacy": "true";
    "data-dd-privacy": DatadogPrivacyMode;
};

/**
 * Get privacy attributes for DOM elements based on Datadog privacy mode.
 * Automatically sets both data-privacy="true" and data-dd-privacy attributes.
 *
 * @param mode - The Datadog privacy level. Defaults to "mask-user-input".
 * @returns Object containing data-privacy and data-dd-privacy attributes
 */
export const getPrivacyAttributes = (
    mode: DatadogPrivacyMode = "mask-user-input"
): PrivacyAttributes => {
    return {
        "data-privacy": "true",
        "data-dd-privacy": mode,
    };
};
